import { LAST_SHARE_LINK_STORAGE_KEY } from '../constants';

type LastShareLinks = Record<string, string>;

function read(): LastShareLinks {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(LAST_SHARE_LINK_STORAGE_KEY) ?? '{}');
    return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed) ? (parsed as LastShareLinks) : {};
  } catch {
    return {};
  }
}

function write(links: LastShareLinks): void {
  if (Object.keys(links).length === 0) {
    localStorage.removeItem(LAST_SHARE_LINK_STORAGE_KEY);
  } else {
    localStorage.setItem(LAST_SHARE_LINK_STORAGE_KEY, JSON.stringify(links));
  }
}

/** Records the share link a guest just opened, so an expired session can be sent back to it. */
export function rememberShareLink(email: string, surfaceUuid: string): void {
  write({ ...read(), [email.toLowerCase()]: surfaceUuid });
}

/** The share link this guest last opened, or `null`. */
export function rememberedShareLink(email: string | null | undefined): string | null {
  return email ? (read()[email.toLowerCase()] ?? null) : null;
}

/** Drops this guest's entry — a refused link must not become where an expired session lands. */
export function forgetShareLink(email: string | null | undefined): void {
  if (!email) {
    return;
  }
  const links: LastShareLinks = read();
  delete links[email.toLowerCase()];
  write(links);
}
